window.env = {};
window.env.apiUrl = "https://api.gad7.info/prod/";
